import { useState } from 'react';
import { PortalUser, WebhookEvents } from 'vopay';
import { useApi } from '#shared/providers/Api';

export default function useFetchWebhookInfo() {
  const api = useApi();
  const [fetchingWebhooks, setFetchingWebhooks] = useState(false);
  const [webhooks, setWebhooks] = useState<WebhookEvents[]>();

  async function fetchWebhookInfo(params: PortalUser) {
    try {
      setFetchingWebhooks(true);
      const res = await api.fetchWebhookInfo(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setWebhooks(res.Webhooks);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingWebhooks(false);
    }
  }

  return { fetchingWebhooks, webhooks, fetchWebhookInfo };
}
